import { apolloVuexSingleStoreFactory } from '../../../libs/ApolloVuexSingleStore'
import { ORGANISATION_GOOGLE_WALLET_QUERY } from "./graphql";

/* eslint-disable no-unused-vars */
let store = apolloVuexSingleStoreFactory({
  settings: {
    fetchQuery: ORGANISATION_GOOGLE_WALLET_QUERY,
    fetchFieldName: 'organisationGoogleWalletSettings',
  }
})
/* eslint-enable no-unused-vars */

export default store